import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../services/auth/authentication.service';
import {Router} from '@angular/router';
import {VvrIconComponent} from "../../vvr-icon/vvr-icon.component";

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    imports: [
        VvrIconComponent
    ]
})
export class LogoutComponent implements OnInit {

    constructor(private authService: AuthenticationService,
                private router: Router) {
    }

    ngOnInit(): void {
        this.authService.logout().subscribe(() => {
            this.router.navigateByUrl('login');
        }, () => {
            this.router.navigateByUrl('login');
        });
    }

}
